import type { ColorScheme } from '../types'

/**
 * Token-name prefix for the given color scheme. Dark-package semantic tokens
 * are namespaced `light.*` for the light palette and unprefixed for dark, so
 * consumers build token paths as `` `${tokenPrefix(mode)}text.primary` ``.
 */
export const tokenPrefix = (colorScheme: ColorScheme = 'dark'): string =>
  colorScheme === 'light' ? 'light.' : ''
